import React from 'react';
//import { useState } from 'react';
import './Choices.scss';

function Choices ({list,addSelected}){
	const useWords = (list)=>{
		const lis = list.map( (value,index)=>{
			const key = "word"+index;
			return (
				<button
					key={key}
					onClick={()=>addSelected(value)}
				>{value}</button>
			);
		})
		return (
			<div className="words">
				{lis}
			</div>
		)
	}
	const words = useWords(list);
	return (
		<div id="choices">
			{words}
		</div>
	);
}

export default Choices;
